import {useEffect, useLayoutEffect} from 'react';

import {canUseDOM} from '../execution-context';

/**
 * A hook that resolves to useEffect on the server and useLayoutEffect on the client
 * @param callback {function} Callback function that is invoked when the dependencies of the hook change
 */
export const useIsomorphicLayoutEffect = canUseDOM
  ? useLayoutEffect
  : useEffect;



// WEBPACK FOOTER //
// ../src/hooks/useIsomorphicLayoutEffect.ts